(function ($) {
    $.widget('ca.caAutocomplete', $.ui.autocomplete, {
        options: {
            url: '',
            data: {},
            limit: 5,
            items: null,
            disabledIds: null,
            changeable: true,
            fieldName: '',
            notFoundText: 'No results found',
            placeholder: 'Search...',
            removeText: 'Remove',
            multiple: false,
            onAfterSuccessCallback: null,
            appendHtml: null,
            minQueryInputLength: 90,
            onChange: function(items) {},

            source: function (request, response) {
                var self = this;
                if (this.options.url) {
                    var data = $.extend(this.options.data, {
                        limit: this.options.limit,
                        input: request.term
                    });

                    $.ajax({
                        url: this.options.url,
                        type: 'POST',
                        dataType: 'json',
                        data: data,
                        success: function (data) {
                            response(data);
                            if (typeof self.options.onAfterSuccessCallback === 'function') {
                                self.options.onAfterSuccessCallback(data);
                            }
                        }
                    });
                }
            },

            select: function (event, ui) {
            },

            beforePressEnter: function (inputText, items) {
            },

            onPressEnter: function (inputText, items) {
            }
        },

        _create: function () {
            var self = this;

            this.options.items = this.options.items != null ? this.options.items : [];
            this.options.disabledIds = this.options.disabledIds != null ? this.options.disabledIds : [];
            this.options.appendTo = $('<span>').addClass('ca-pro-ui').appendTo('body');

            if (this.options.disabledIds.length > 0) {
                $.each(this.options.disabledIds, function (index, value) {
                    self.options.disabledIds[index] = value.toString();
                });
            }

            this.element.caText({
                placeholder: this.options.placeholder
            });

            var length = this.options.items.length;
            if (!this.options.multiple) {
                if (length > 1) {
                    this.options.items.splice(1, length - 1);
                }
            }

            $.each(this.options.items, function (index, value) {
                self.setItem(value, true);
            });

            this.setChangeable(this.options.changeable);

            $.ui.autocomplete.prototype._create.call(this);

            this.element.parent().on('click', 'a', function () {
                var id = $(this).parent().find('input[type=hidden]').val();
                var label = $(this).parent().find('span').text();
                var item = {
                    id: id,
                    label: label
                };

                $(this).parent().remove();
                self.clearItem(item);
                self._updateAutoComplete();

                if (!self.options.multiple) {
                    self.element.show();
                    self.element.blur();
                }

                return false;
            });

            this.options.select = function (event, ui) {
                self.setItem(ui.item);

                return false;
            };

            this.element.keypress(function (e) {
                if (e.keyCode == 13 || e.keyCode == 10) {
                    var text = self.element.val();
                    self.options.beforePressEnter.call(self, text, self.getItems());
                    self.options.onPressEnter.call(self, text, self.getItems());
                }
            });

        },

        _updateAutoComplete: function () {
            var data = this.options.data;
            if (data.doNotShow === undefined) {
                data.doNotShow = [];
            }
            if (!$.isArray(data.doNotShow)) {
                data.doNotShow = [data.doNotShow];
            }
            this.element.parent().find('input[type=hidden]').each(function () {
                var itemId = $(this).val();

                if ($.inArray(itemId, data.doNotShow) === -1) {
                    data.doNotShow.push(itemId);
                    return false;
                }
            });

            var doNotShow = [];
            $.each(this.options.data.doNotShow, function (index, value) {
                doNotShow.push(value.toString());
            });
            this.options.data.doNotShow = doNotShow;

            if (this.options.multiple) {
                var tags = this.element.parent().find('.tag');
                var filledWidth = 8;
                if (tags.length > 0) {
                    filledWidth = tags.last().position().left + tags.last().outerWidth();
                }
                var controlWidth = this.element.parent().width() - 5;
                var emptySpace = controlWidth - filledWidth;
                if (emptySpace <= this.options.minQueryInputLength) {
                    emptySpace = controlWidth;
                }
                this.element.attr('style', 'width:' + emptySpace + 'px !important');
            }
        },

        escapeRegExpChars: function(value) {
            return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
        },

        _renderItem: function (ul, item) {
            var li = $('<li>').data('item.autocomplete', item);
            var a = $('<a>').appendTo(li);

            var nameWithHighlightedTerm = item.label;
            if (item.label) {
                var escapedValue = this.escapeRegExpChars(this.term);
                nameWithHighlightedTerm =
                    item.highlightLabel
                    || item.label.replace(
                        new RegExp($.trim(escapedValue), "gi"),
                        '<span class="autocomplete-highlighted" >$&</span>'
                    );
            }

            a.html(nameWithHighlightedTerm);
            li.appendTo(ul);
            ul.addClass('dropdown-menu');

            return li;
        },

        _suggest: function (items) {
            var self = this;
            items = $.map(items, function(item) {
                if ($.inArray(item.id.toString(), self.options.data.doNotShow) === -1) {
                    return item;
                }
            });
            $.ui.autocomplete.prototype._suggest.call(this, items);

            var menu = this.menu.element;

            menu.addClass('ca-autocomplete-menu').removeClass('ui-widget-content');
            menu.find('li a').removeClass('ui-corner-all');

            if (items.length == 0) {
                $('<li class="item-not-found">' + self.options.notFoundText + '</li>').appendTo(menu);
            }
            if (this.options.appendHtml) {
                $(this.options.appendHtml).appendTo(menu);
            }
        },

        __response: function (content) {
            this._trigger("response", null, {content: content});
            if (!this.options.disabled && !this.cancelSearch) {
                this._suggest(content);
                this._trigger("open");
            } else {
                // use ._close() instead of .close() so we don't cancel future searches
                this._close();
            }
        },

        setItem: function (item, silent) {
            var self = this;
            this.element.val('');

            var isNewItem = true;
            for (var i = 0; i < this.options.items.length; i++) {
                if (this.options.items[i].id === item.id) {
                    isNewItem = false;
                }
            }

            if (isNewItem) {
                if (!(self.options.maxItems == null || self.options.items.length < self.options.maxItems)) {
                    self._trigger("reachedmaxitems", null, {
                        maxItems: self.options.maxItems
                    });
                    return false;
                }
            }

            var text = this.capitalizeFirstLetter(item.label.toString());
            var itemText = $('<span>' + text + ' </span>');
            var catitle = '';

            if (this.options.removeText) {
                catitle = 'catitle="' + this.options.removeText + '"';
            }

            var cross = $('<a href="javascript:void(0);" class="catitle-button" ' + catitle + '>x</a>');

            var fieldName;
            if (this.options.fieldName) {
                fieldName = this.options.fieldName;
            } else {
                fieldName = this.element.attr('id') + (self.options.multiple ? '[]' : '');
            }

            var inputValue = item.id;
            if (item.id === '-1') {
                inputValue = item.label;
            }
            var itemInput = $('<input type="hidden" value="' + inputValue + '" name="' + fieldName + '">');

            var newElement = $('<span>')
                .addClass('tag')
                .append(itemText)
                .append(cross)
                .append(itemInput)
                .insertBefore(self.element);

            if (isNewItem) {
                this.options.items[this.options.items.length] = {
                    id: item.id,
                    label: item.label
                };
            }

            this._updateAutoComplete();
            this.cutItemLabel(item.label, newElement);

            if (!this.options.multiple) {
                this.element.hide();
            }

            if (!silent) {
                this.options.onChange(this.getItems());
            }

            self._trigger("itemadded", {}, item);
        },

        getItem: function () {
            return this.options.items[0] !== undefined
                ? this.options.items[0]
                : null;
        },

        getItems: function () {
            return this.options.items;
        },

        clearItem: function (item, silent) {
            var self = this;

            this._trigger("itemremoved", {}, item);
            this._trigger("deselect", {}, {item: item});

            if (typeof(item) === "undefined") {
                var itemsCount = this.options.items.length;
                if (itemsCount) {
                    item = this.options.items[itemsCount - 1];
                }
            }

            if (typeof(item) !== "undefined") {
                item.id = item.id.toString();

                var itemIndex = -1;
                $.each(this.options.items, function (index, value) {
                    if (value.id.toString() === item.id) {
                        itemIndex = index;
                    }
                });
                if (itemIndex > -1) {
                    self.options.items.splice(itemIndex, 1);
                    if (item.id === '-1') {
                        this.element.parent().find('input[value="' + item.label + '"]').parent().remove();
                    } else {
                        this.element.parent().find('input[value=' + item.id + ']').parent().remove();
                    }
                    this.element.show();
                }

                var doNotShow = this.options.data.doNotShow;
                if (doNotShow) {
                    doNotShow.splice($.inArray(item.id, doNotShow), 1);
                }

                this.element.focus();
            }

            this._trigger("afteritemremoved", {}, item);
            if (!silent) {
                this.options.onChange(this.getItems());
            }
        },

        setChangeable: function (changeable) {
            var self = this;
            this.options.changeable = changeable ? true : false;
            var itemCount = this.options.items.length;

            if (changeable) {
                if (!this.options.multiple && itemCount === 1) {
                    this.element.hide();
                } else {
                    this.element.show();
                }

                this.element.parent().find('a').show();
                this.element.parent().find('.tag').each(function () {

                });

                this.element.parent().find('.tag').each(function () {
                    if ($.inArray($(this).find('input').val(), self.options.disabledIds) > -1) {
                        $(this).find('a').hide();
                        $(this).css('padding-right', '6px');
                    } else {
                        $(this).css('padding-right', '20px');
                    }
                });
            } else {
                this.element.hide();
                this.element.parent().find('a').hide();
                this.element.parent().find('.tag').each(function () {
                    $(this).css('padding-right', '6px');
                });
            }
        },

        capitalizeFirstLetter: function (str) {
            return str.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        },

        cutItemLabel: function (label, element) {
            var testItemTextLength = $('<span>' + label + ' </span>');
            testItemTextLength.appendTo('body');
            var itemTextWidth = testItemTextLength.outerWidth();
            testItemTextLength.remove();
            var controlWidth = this.element.parent().width();
            var percentageWidthValue = '100';

            if (itemTextWidth > controlWidth && controlWidth != percentageWidthValue) {
                element.width(controlWidth - 18);
                element.find('span').width(controlWidth - 43);

                element.find('span').css({
                    'position': 'absolute',
                    'overflow': 'hidden'
                });
                element.css('overflow', 'hidden');
            }
        },

        _setOption: function (key, value) {
            $.ui.autocomplete.prototype._setOption.call(this, key, value);
            if (key == 'placeholder') {
                this.element.caText({
                    placeholder: this.options.placeholder
                });
                this.element.focus();
                this.element.blur();
            }
        }
    });
    $.extend( $.ui.autocomplete, {
        filter: function (array, term) {
            if (term == ' ') {
                return array;
            }
            var matcher = new RegExp($.ui.autocomplete.escapeRegex(term), "i");
            return $.grep(array, function (value) {
                return matcher.test(value.label || value.value || value);
            });
        }
    });
})(jQuery);
